import type { TransferOption } from './index.types';

export const TRANSFER_OPTIONS: TransferOption[] = [
  {
    value: 'blind',
    label: 'Blind transfer',
    description: 'Transfer the call to another contact',
  },
  {
    value: 'warm',
    label: 'Warm transfer',
    description: 'Talk with contact before transferring the call',
  },
  {
    value: 'voicemail',
    label: 'Transfer to voicemail',
    description: "Transfer the call to the contact’s voicemail",
  },
];
